import { render, staticRenderFns } from "./designRenderer.vue?vue&type=template&id=78bddb48&"
import script from "./designRenderer.vue?vue&type=script&lang=ts&"
export * from "./designRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./designRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports